module.exports = __webpack_public_path__ + "img/treatments-directory-card-mobile-fr.9961da51.jpg";